import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class GravelRoadTileEntity6 extends TileEntity {
	public static readonly frameName = FrameName.GRAVEL_ROAD_6;
}

export default GravelRoadTileEntity6;
